import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PAGE_META } from "@/data/content";

const SITE_ORIGIN = "https://rbtim.com";

const containsProductSchema = (value) => {
  if (!value || typeof value !== "object") return false;

  if (Array.isArray(value)) {
    return value.some(containsProductSchema);
  }

  const type = value["@type"];
  if (type === "Product" || (Array.isArray(type) && type.includes("Product"))) {
    return true;
  }

  return Object.values(value).some(containsProductSchema);
};

const removeBrokenProductSchemas = () => {
  document.querySelectorAll('script[type="application/ld+json"]').forEach((script) => {
    const raw = script.textContent || "";

    try {
      const data = JSON.parse(raw);
      if (containsProductSchema(data)) {
        script.remove();
      }
    } catch (error) {
      if (raw.includes('"@type"') && raw.includes("Product")) {
        script.remove();
      }
    }
  });
};

const SEO = ({ title, description }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    removeBrokenProductSchemas();

    const meta = PAGE_META[pathname] || {};

    const finalTitle =
      title || meta.title || "RB TIM | Standardni kontejneri";

    const finalDesc =
      description ||
      meta.description ||
      "RB TIM izrađuje standardne kontejnere za stanovanje, kancelarije, gradilišta, sanitarne potrebe, portirnice i pomoćne objekte.";

    const currentUrl = `${SITE_ORIGIN}${pathname === "/" ? "/" : pathname}`;

    document.title = finalTitle;

    const ensureMeta = (selector, attrs) => {
      let el = document.querySelector(selector);

      if (!el) {
        el = document.createElement("meta");
        Object.entries(attrs).forEach(([key, value]) => {
          el.setAttribute(key, value);
        });
        document.head.appendChild(el);
      }

      return el;
    };

    ensureMeta('meta[name="description"]', {
      name: "description",
    }).setAttribute("content", finalDesc);

    ensureMeta('meta[name="robots"]', {
      name: "robots",
    }).setAttribute("content", "index, follow");

    ensureMeta('meta[property="og:title"]', {
      property: "og:title",
    }).setAttribute("content", finalTitle);

    ensureMeta('meta[property="og:description"]', {
      property: "og:description",
    }).setAttribute("content", finalDesc);

    ensureMeta('meta[property="og:type"]', {
      property: "og:type",
    }).setAttribute("content", "website");

    ensureMeta('meta[property="og:locale"]', {
      property: "og:locale",
    }).setAttribute("content", "sr_RS");

    ensureMeta('meta[property="og:url"]', {
      property: "og:url",
    }).setAttribute("content", currentUrl);

    let canonical = document.querySelector('link[rel="canonical"]');

    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }

    canonical.setAttribute("href", currentUrl);
  }, [pathname, title, description]);

  return null;
};

export default SEO;
